import { useEffect } from 'react';

/**
 * How many of the quiet states are on screen — sign-in, not-staff, a refusal, and the
 * request for access. While one is, the cluster poller takes a new value as this tab's own
 * rather than reloading it (`manifests-draw-the-nav` D11; a reload mid-sign-in would throw
 * away a typed password or a pending challenge, `staff-sign-in-here` D11).
 *
 * Flutter's `/loading` is a state here and not a path; sign-in is a surface of the admin's
 * own, and `/admin-access` is a route of its own which must still be quiet
 * (`request-access-is-a-page` D2).
 *
 * Its own module, not `Shell.tsx`'s: a surface the shell renders must be able to be quiet
 * without importing the module that renders it, which would import it back.
 */
let quiet = 0;

export function isQuiet(): boolean {
  return quiet > 0;
}

export function useQuietShell(): void {
  useEffect(() => {
    quiet += 1;
    return () => {
      quiet -= 1;
    };
  }, []);
}
